import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Stepper from "./stepper";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";

export const Step2 = ({ prevStep, nextStep, handleChange, values }) => {
  const { t } = useTranslation("global");
  const {
    register,
    trigger,
    formState: { errors },
  } = useForm();

  // validation message for zip, email & phone fields
  var requiredValidZipMessage;
  var requiredValidEmailMessage;
  var requiredValidPhoneMessage;

  const navigate = useNavigate();

  const Previous = (e) => {
    e.preventDefault();
    prevStep();
    navigate(
      `/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}`
    );
  };

  const Continue = (e) => {
    e.preventDefault();
    // validate fields
    trigger().then((r) => {
      // if fields completed as required, move to next step
      if (
        r === true &&
        !requiredValidEmailMessage &&
        !requiredValidPhoneMessage &&
        !requiredValidZipMessage
      ) {
        nextStep();
        navigate(
          `/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=vehicles`
        );
      }
    });
  };

  const handleKeyEnter = async (event) => {
    if (event.keyCode === 13) {
      await trigger();
      // if fields completed as required, move to next step
      if (values.businessPhone.length === 12) {
        nextStep();
        navigate(
          `/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=vehicles`
        );
      }
    }
  };
  // console.log(values.businessPhone.length);
  // console.log("Values", values);
  // console.log("Values ZIP", values.availableZipCode);
  // check if business email contains @
  if (values.businessMailingZipCode) {
    const businessZip = values.businessMailingZipCode;
    //Added validation for email
    if (/^\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d$/.test(businessZip)) {
      // console.log("businessZip", businessZip);
      requiredValidZipMessage = false;
    } else {
      // console.log("else businessZip", businessZip);
      requiredValidZipMessage = (
        <p className="require-field-message">{t("requiredValidZip")}</p>
      );
    }
  }
  // check if business email contains @
  if (values.businessEmail) {
    const email = values.businessEmail;
    //Added validation for email
    if (
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      requiredValidEmailMessage = false;
    } else {
      requiredValidEmailMessage = (
        <p className="require-field-message">{t("requiredValidEmail")}</p>
      );
    }
  }

  // check if business phone contains only numbers
  if (values.businessPhone) {
    // let isnum = /^\d+$/.test(values.businessPhone);
    let isnum = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(
      values.businessPhone
    );
    if (isnum) {
      requiredValidPhoneMessage = null;
    } else {
      requiredValidPhoneMessage = (
        <p className="require-field-message">{t("requiredValidPhone")}</p>
      );
    }
  }

  if (values.availableZipCode === true) {
    return (
      <Container style={{ marginTop: "2%" }}>
        <Row>
          <Col lg={3}></Col>
          <Col lg={7}>
            <div className="page-texts">
              <p className="title">{t("step2.page.title")}</p>
              <p className="subtitle">{t("step2.page.subtitle")}</p>
            </div>
          </Col>
        </Row>

        <Row style={{ marginTop: "1rem" }}>
          <Col lg={3}>
            <Stepper step="1" t={t}></Stepper>
          </Col>
          <Col lg={7}>
            <div className="form-texts">
              <p className="title">{t("step2.form.title")}</p>
              <p className="subtitle">{t("step2.form.subtitle")}</p>
            </div>

            <Form>
              <Row>
                <Form.Group as={Col}>
                  <Form.Label>{t("step2.form.firstName.label")}</Form.Label>
                  <Form.Control
                    {...register("firstName", { required: true })}
                    type="text"
                    value={values.firstName}
                    onChange={handleChange("firstName")}
                  />
                  {errors.firstName && (
                    <p className="require-field-message">
                      {t("requiredFieldMessage")}
                    </p>
                  )}
                </Form.Group>

                <Form.Group as={Col}>
                  <Form.Label>{t("step2.form.lastName.label")}</Form.Label>
                  <Form.Control
                    {...register("lastName", { required: true })}
                    type="text"
                    value={values.lastName}
                    onChange={handleChange("lastName")}
                  />
                  {errors.lastName && (
                    <p className="require-field-message">
                      {t("requiredFieldMessage")}
                    </p>
                  )}
                </Form.Group>
              </Row>
              <br />

              <Row>
                <Form.Group as={Col}>
                  <Form.Label>{t("step2.form.businessName.label")}</Form.Label>
                  <Form.Control
                    type="text"
                    value={values.businessName}
                    onChange={handleChange("businessName")}
                  />
                </Form.Group>

                <Form.Group as={Col}>
                  <Form.Label>
                    {t("step2.form.businessMailingZipCode.label")}
                  </Form.Label>
                  <Form.Control
                    {...register("businessMailingZipCode", { required: true })}
                    placeholder="#####"
                    value={values.businessMailingZipCode}
                    onChange={handleChange("businessMailingZipCode")}
                  />
                  {errors.businessMailingZipCode && (
                    <p className="require-field-message">
                      {t("requiredFieldMessage")}
                    </p>
                  )}
                </Form.Group>
              </Row>
              <br />

              <Row>
                <Form.Group as={Col}>
                  <Form.Label>{t("step2.form.businessEmail.label")}</Form.Label>
                  <Form.Control
                    {...register("businessEmail", { required: true })}
                    type="email"
                    pattern='/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/'
                    value={values.businessEmail}
                    onChange={handleChange("businessEmail")}
                  />
                  {errors.businessEmail && (
                    <p className="require-field-message">
                      {t("requiredFieldMessage")}
                    </p>
                  )}
                  {requiredValidEmailMessage}
                </Form.Group>

                <Form.Group as={Col}>
                  <Form.Label>{t("step2.form.businessPhone.label")}</Form.Label>
                  <Form.Control
                    {...register("businessPhone", { required: true })}
                    onKeyUp={handleKeyEnter}
                    value={values.businessPhone}
                    onChange={handleChange("businessPhone")}
                    type="text"
                    placeholder="###-###-####"
                  />
                  {errors.businessPhone && (
                    <p className="require-field-message">
                      {t("requiredFieldMessage")}
                    </p>
                  )}
                  {requiredValidPhoneMessage}
                </Form.Group>
              </Row>
              <br />

              <Row>
                <Col lg={4}>
                  <Link
                    to={`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}`}
                  >
                    <Button
                      variant="outline-dark"
                      onClick={Previous}
                      style={{ width: "100%" }}
                    >
                      {t("step2.form.prevButton")}
                    </Button>
                  </Link>
                </Col>
                <Col lg={5}>
                  <Link
                    to={`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=vehicles`}
                  >
                    <Button
                      variant="success"
                      onClick={Continue}
                      style={{ width: "100%" }}
                    >
                      {t("step2.form.nextButton")}
                    </Button>
                  </Link>
                </Col>
                {/* <Col lg={4}></Col> */}
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  } else {
    return (
      <Container style={{ marginTop: "2%" }}>
        <Row>
          <Col lg={3}></Col>
          <Col lg={7}>
            <div className="page-texts">
              <p className="title">{t("step2.page.title")}</p>
              <p className="subtitle">{t("step2.page.subtitle")}</p>
            </div>
          </Col>
        </Row>

        <Row style={{ marginTop: "1rem" }}>
          <Col lg={3}>
            <Stepper step="1" t={t}></Stepper>
          </Col>
          <Col lg={7}>
            <div className="form-texts">
              <p className="title" style={{ color: "#253244" }}>
                {" "}
                {t("step2.message.zipCodeOutsideOfCalculator")}{" "}
              </p>
            </div>
            <Row style={{ marginTop: "1rem" }}>
              <Col lg={4}>
                <Button
                  variant="outline-dark"
                  onClick={Previous}
                  style={{ width: "100%" }}
                >
                  {t("step2.form.prevButton")}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
};

export default Step2;
